import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "deliveryEstimate.m" */ "./Loadable"));
